// Small category labels shown as static, fully rounded (pill) chips instead of all-caps overline text.
// M3 chips are 32dp tall with 8dp corners; the pill shape and the two sizes below are a deliberate choice for these labels.
// Props: text (string split on "·" / "•" into one pill per part) or items (string[]); tone: Chip tone (default 'primary');
//        size: 'small' (24dp, label-medium) | 'large' (40dp, title-small). Default: small inside a SurfaceCard, large outside.
(function () {
  const { Box } = MaterialUI;

  const SIZES = {
    small: { height: 24, fontSize: '0.75rem', lineHeight: '16px', px: 1.5 },
    large: { height: 40, fontSize: '0.875rem', lineHeight: '20px', px: 2.5 }
  };

  function LabelPills({ text, items, tone = 'primary', size, sx = {} }) {
    const { Chip, InCardContext } = window.Components;
    const inCard = React.useContext(InCardContext);
    const z = SIZES[size || (inCard ? 'small' : 'large')];
    const parts = (items || String(text || '').split(/[·•]/)).map(s => String(s).trim()).filter(Boolean);
    if (!parts.length) return null;
    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, ...sx }}>
        {parts.map((p, n) => (
          <Chip key={n} tone={tone} label={p}
            sx={{ borderRadius: 'var(--m3-shape-full)', height: z.height, fontSize: z.fontSize, lineHeight: z.lineHeight, '& .MuiChip-label': { px: z.px, overflow: 'hidden', textOverflow: 'ellipsis' } }} />
        ))}
      </Box>
    );
  }

  window.Components = window.Components || {};
  window.Components.LabelPills = LabelPills;
})();
